module.exports = __webpack_public_path__ + "img/sj@2x.c252c479.png";